/* @flow */
import GroupStore from 'groups/stores/GroupStore';
import { EVERYONE } from 'utils/roleHelpers';
import { Target, TARGET_TYPES } from 'entities/Message';

export function getTargetsFromGroupCodes(groupCodes: string[]): Target[] {
  const targets = [];
  groupCodes.forEach((gc: string) => {
    const group = GroupStore.getGroupForCode(gc);
    if (group) {
      const roles = group.getPostableRoles();
      if (roles.length) {
        const target = roles.includes(EVERYONE) ?
          { type: TARGET_TYPES.GROUP_TARGET, role: EVERYONE, group_id: group.id } :
          { type: TARGET_TYPES.GROUP_TARGET, role: roles[0], group_id: group.id };
        targets.push(target);
      }
    }
  });
  return targets;
}



// WEBPACK FOOTER //
// ./src/lib/getTargetsFromGroupCodes.js